import React from "react";

const blogs = [
    {
        date: "15",
        month: "Dec",
        title: "Fixing Tailbone Back Problems Possible",
        img: "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=600&q=80",
    },
    {
        date: "21",
        month: "Jan",
        title: "Make Your Own Expanding Contracting Content",
        img: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=600&q=80",
    },
    {
        date: "29",
        month: "Jan",
        title: "How to Remedy Tailbone Back Problems",
        img: "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=800&q=80",
    },
    {
        date: "16",
        month: "Feb",
        title: "Fixing Tailbone Back Problems Possible",
        img: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=600&q=80",
    },
    {
        date: "22",
        month: "Feb",
        title: "Make Your Own Expanding Contracting Content",
        img: "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=800&q=80",
    },
    {
        date: "28",
        month: "Feb",
        title: "How to Remedy Tailbone Back Problems",
        img: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=600&q=80",
    },
];

const BlogCards = () => {
    return (
        <section className="container py-5">
            <div className="row g-4">
                {blogs.map((item, index) => (
                    <div className="col-lg-4 col-md-6" key={index}>
                        <div className="blog-card">
                            <div className="blog-img">
                                <img src={item.img} alt="" />

                                {/* Date Badge */}
                                <div className="date-box1">
                                    <span>{item.date}</span>
                                    <small>{item.month}</small>
                                </div>
                            </div>

                            <div className="blog-content">
                                {/* Meta with icons */}
                                <div className="blog-meta">
                                    <span>
                                        <i className="bi bi-person"></i> By Admin
                                    </span>
                                    <span>
                                        <i className="bi bi-check-circle-fill"></i> Technology
                                    </span>
                                </div>

                                <h5>{item.title}</h5>

                                <a href="#" className="read-more">
                                    Read More <i className="bi bi-arrow-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Pagination */}
            <div className="pagination-wrap mt-5">
                <button>
                    <i className="bi bi-arrow-left"></i>
                </button>
                <button>01</button>
                <button className="active">02</button>
                <button>03</button>
                <button>
                    <i className="bi bi-arrow-right"></i>
                </button>
            </div>
        </section>
    );
};

export default BlogCards;
